import { Controller } from 'stimulus'

// Drives the review step of the timetable import wizard: a shared searchable
// event-picker modal plus one-click suggestion buttons that fill each event
// group's hidden event id and switch its decision to "Link event".
export default class extends Controller {
  static targets = ['modal', 'modalSearch', 'modalList', 'modalOption', 'modalEmpty']

  openModal (event) {
    const button = event.currentTarget
    this.activeField = button.dataset.field
    this.activeChip = button.dataset.chip
    this.activeRadio = button.dataset.radio

    this.modalTarget.classList.remove('d-none')
    document.body.classList.add('rbi-modal-open')
    this.modalSearchTarget.value = ''
    this.filterModal()
    this.modalSearchTarget.focus()
  }

  closeModal () {
    this.modalTarget.classList.add('d-none')
    document.body.classList.remove('rbi-modal-open')
    this.activeField = null
    this.activeChip = null
    this.activeRadio = null
  }

  filterModal () {
    const query = this.modalSearchTarget.value.trim().toLowerCase()
    let visible = 0

    this.modalOptionTargets.forEach((option) => {
      const matches = query === '' || option.dataset.searchText.includes(query)
      option.classList.toggle('d-none', !matches)
      if (matches) visible += 1
    })

    if (this.hasModalEmptyTarget) {
      this.modalEmptyTarget.classList.toggle('d-none', visible > 0)
    }
  }

  pickEvent (event) {
    const option = event.currentTarget
    this.applySelection(this.activeField, this.activeChip, this.activeRadio,
      option.dataset.eventId, option.dataset.eventName)
    this.closeModal()
  }

  useSuggestion (event) {
    const button = event.currentTarget
    this.applySelection(button.dataset.field, button.dataset.chip, button.dataset.radio,
      button.dataset.eventId, button.dataset.eventName)
  }

  applySelection (fieldId, chipId, radioId, eventId, eventName) {
    if (!fieldId) return

    const field = document.getElementById(fieldId)
    if (field) field.value = eventId

    const chip = document.getElementById(chipId)
    if (chip) {
      chip.classList.remove('d-none')
      const label = chip.querySelector('.rb-chip__label')
      if (label) label.textContent = eventName
    }

    const radio = document.getElementById(radioId)
    if (radio) radio.checked = true
  }
}
